import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {AppState} from '../reducer';

export const sidebarSelector = (state: AppState): boolean => state.layoutReducer.isSidebarCollapsed;
export const desktopViewSelector = (state: AppState): boolean => state.layoutReducer.isDesktopViewSelected;
export const fullscreenSelector = (state: AppState): boolean => state.layoutReducer.isFullScreen;
export const selectedDeviceTypeSelector = (state: AppState): DeviceType => state.layoutReducer.selectedDeviceType;
